module.exports = __webpack_public_path__ + "static/assets/7d8465ba0af4472fdab60b2c439e6880.png";